import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { ProductUse, productUsageAttributeType } from '../../types/slices/productUsageAttributeType'

const initialState: productUsageAttributeType =
{
    status: ApiStatus.FETCHED,
    productUsageAttributes: [],
    productUseSelected: {} as ProductUse,
    errorMessage: undefined,
    action: ''
}

const ProductUsageAttributeSlice = createSlice({
    name: 'ProductUsageAttributeSlice',
    initialState,
    reducers: {
        onFetchProductUse (state, { payload }: { payload: ProductUse[]}) {
        state.status = ApiStatus.FETCHED
        state.productUsageAttributes = payload
        state.errorMessage = undefined
        },
        onSetSelectedProductUse (state, { payload }: { payload: ProductUse }) {
        state.productUseSelected = payload
        },
        changeStatus (state, { payload }: { payload: ApiStatus}){
        state.status = payload
        },
        setAction (state, { payload }: { payload: string }) {
        state.action = payload
        },
    }
})

export const selectProductUseState = (state: RootState) => state.ProductUsageAttributeSlice
export default ProductUsageAttributeSlice.reducer
export const {
    onFetchProductUse,
    onSetSelectedProductUse,
    changeStatus,
    setAction,
} = ProductUsageAttributeSlice.actions
